import React, { useEffect, useState } from "react";
import { Button, ShowProps } from "react-admin";
import { Grid, makeStyles, Tab, Tabs, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { PICResource } from "utils/tools";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import IconPlus from "@material-ui/icons/Add";
import InvoiceTable from "pages/commercialDocuments/components/InvoiceTable";
import TabPanel from "pages/routeplans/components/TabPanel";
import ApproveUntaggedCreditNotesTable from "../commercialDocuments/components/ApproveUntaggedCreditNotesTable";
import UnapprovedInvoiceTable from "../unapprovedInvoices/components/UnapprovedInvoiceTable";
import UnapprovedCreditNoteTable from "../unapprovedCreditNotes/components/UnapprovedCreditNoteTable";

const useStyles = makeStyles({
  sidePanelTabs: {
    borderBottom: "1px solid #C4C4C4",
    "& .MuiTabs-fixed > .MuiTabs-indicator": {
      backgroundColor: "#989898 !important",
      height: "3px !important",
    },
  },
});

const Financial = (props: ShowProps) => {
  const [isEnableButton, setIsEnableButton] = useState<boolean>(false);
  const [valueUnpostedTab, setValueUnpostedTab] = React.useState(0);
  const [valuePostedTab, setValuePostedTab] = React.useState(0);

  const classes = useStyles();

  const handleChangeUnpostedTab = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setValueUnpostedTab(newValue);
  };

  const handleChangePostedTab = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setValuePostedTab(newValue);
  };

  const unpostedProps = (index: number) => {
    return {
      id: `unposted-tab-${index}`,
      "aria-controls": `unposted-tabpanel-${index}`,
    };
  };

  const postedProps = (index: number) => {
    return {
      id: `posted-tab-${index}`,
      "aria-controls": `posted-tabpanel-${index}`,
    };
  };

  const { id } = props;

  const pICResource = PICResource(Number(id));
  const navMode = useSelector((state: any) => state.navMode.mode);

  useEffect(() => {
    if (navMode === "FINANCE" || navMode === "CUSTOMER_SERVICE") {
      setIsEnableButton(true);
    } else {
      setIsEnableButton(false);
    }
  }, [navMode]);

  const InvoiceCreateButton = () => {
    const history = useHistory();
    return (
      <Button
        onClick={() =>
          history.push(
            `/commercialDocuments/create?source=${JSON.stringify({
              parentId: Number(pICResource.id),
              type: "invoice",
            })}&type=Invoice&parentId=${
              pICResource.id
            }&personType=personInCharges`
          )
        }
        label="Adhoc Invoice"
      >
        <IconPlus />
      </Button>
    );
  };

  const CreditNoteCreateButton = () => {
    const history = useHistory();
    return (
      <Button
        onClick={() =>
          history.push(
            `/commercialDocuments/create?source=${JSON.stringify({
              parentId: Number(pICResource.id),
              type: "credit_note",
            })}&type=CreditNote&parentId=${
              pICResource.user.accountingCustomerId
            }&personType=personInCharges`
          )
        }
        label="Credit Note"
      >
        <IconPlus />
      </Button>
    );
  };

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Financial Information</Typography>
        </Grid>

        {isEnableButton && (
          <>
            <Grid item xs={8}>
              <InvoiceCreateButton />
              <CreditNoteCreateButton />
            </Grid>
            <Grid item xs={4} />
          </>
        )}

        <Grid item xs={12}>
          <Tabs
            value={valueUnpostedTab}
            onChange={handleChangeUnpostedTab}
            aria-label="Unposted Commercial Document"
            className={classes.sidePanelTabs}
          >
            <Tab label="Unapproved Invoices" {...unpostedProps(0)} />
            <Tab label="Unapproved Credit Notes" {...unpostedProps(1)} />
          </Tabs>

          <TabPanel value={valueUnpostedTab} index={0}>
            <Grid item xs={12}>
              <UnapprovedInvoiceTable
                userId={pICResource.user.id}
                isFixedHeight
              />
            </Grid>
          </TabPanel>

          <TabPanel value={valueUnpostedTab} index={1}>
            <Grid item xs={12}>
              <UnapprovedCreditNoteTable
                userId={pICResource.user.id}
                isFixedHeight
              />
            </Grid>
          </TabPanel>
        </Grid>

        <Grid item xs={12}>
          <Tabs
            value={valuePostedTab}
            onChange={handleChangePostedTab}
            aria-label="Approved Commercial Document"
            className={classes.sidePanelTabs}
          >
            <Tab label="Approved Invoices" {...postedProps(0)} />
            <Tab label="Approved Untagged Credit Notes" {...postedProps(1)} />
          </Tabs>

          <TabPanel value={valuePostedTab} index={0}>
            <Grid item xs={12}>
              <InvoiceTable
                status={"Posted"}
                customerId={pICResource.user.accountingCustomerId}
              />
            </Grid>
          </TabPanel>

          <TabPanel value={valuePostedTab} index={1}>
            <Grid item xs={12}>
              <ApproveUntaggedCreditNotesTable
                customerId={pICResource.user.accountingCustomerId}
              />
            </Grid>
          </TabPanel>
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Financial;
